import {
  FaAddressBook,
  FaCheckCircle,
  FaFileAlt,
  FaGavel,
  FaProjectDiagram,
  FaShoppingCart,
  FaSitemap,
  FaStore,
  FaTasks,
} from "react-icons/fa";

const BASE = "/super-admin/p2p";

/**
 * P2P sidebar items shown for legacy infra Super Admin (`p2p.is_super_admin`).
 * Mirrored here for isolated Super Admin login.
 */
export const SUPER_ADMIN_P2P_ITEMS = [
  {
    id: "p2p_platform_admin_management",
    label: "P2P Platform Admin Management",
    to: `${BASE}/platform-admin-management`,
    icon: FaSitemap,
    end: true,
  },
  {
    id: "p2p_access_diagnostics",
    label: "P2P access diagnostics (UAT)",
    to: `${BASE}/diagnostics`,
    icon: FaFileAlt,
    end: true,
  },
  {
    id: "p2p_organization_setup",
    label: "Company Control Setup",
    to: `${BASE}/organization-setup`,
    icon: FaSitemap,
    end: true,
  },
  {
    id: "p2p_approval_setup",
    label: "Approval Matrix",
    to: `${BASE}/approval-setup`,
    icon: FaTasks,
    end: true,
  },
  {
    id: "p2p_sales_auction_controls",
    label: "Sales & Auction Controls",
    to: `${BASE}/approval-setup?domain=sales`,
    icon: FaGavel,
    end: true,
  },
  {
    id: "p2p_my_approvals",
    label: "My approvals",
    to: `${BASE}/my-approvals`,
    icon: FaCheckCircle,
    end: true,
  },
  {
    id: "p2p_command_centre",
    label: "Procurement Command Centre",
    to: `${BASE}/command-centre`,
    icon: FaProjectDiagram,
    activePathPrefix: `${BASE}/transactions`,
  },
  {
    id: "p2p_preapproved_vendors",
    label: "Pre-approved vendors",
    to: `${BASE}/preapproved-vendors`,
    icon: FaAddressBook,
    end: true,
  },
  {
    id: "p2p_services_catalogue",
    label: "Procurement-as-a-Service",
    to: `${BASE}/services`,
    icon: FaStore,
    end: true,
  },
  {
    id: "p2p_platform_services_admin",
    label: "Platform services (P2P Platform Admin)",
    to: `${BASE}/platform-services`,
    icon: FaSitemap,
    end: true,
  },
  {
    id: "p2p_service_console",
    label: "P2P Platform Admin Console",
    to: `${BASE}/service-console`,
    icon: FaTasks,
    end: true,
  },
  {
    id: "p2p_insights",
    label: "P2P Insights",
    to: `${BASE}/insights`,
    icon: FaFileAlt,
    end: true,
  },
];

export const SUPER_ADMIN_P2P_GROUP = {
  id: "p2p",
  heading: "Procure-to-Pay",
  icon: FaShoppingCart,
  items: SUPER_ADMIN_P2P_ITEMS,
};

export const isSuperAdminP2pPath = (pathname = "") =>
  pathname.startsWith(`${BASE}/`) || pathname === BASE;
